"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetKebabFormat = GetKebabFormat;

var _react = _interopRequireDefault(require("react"));

var _kebabFormat = require("./kebab-format");

var _taggingHelper = require("@eig-builder/core-utils/helpers/tagging-helper");

function GetKebabFormat(params) {
  return /*#__PURE__*/_react["default"].createElement(_kebabFormat.KebabFormat, {
    kebabItems: params.colDef.kebabMenuItems,
    record: params.data,
    value: params.data[params.colDef.name],
    dataElementLocation: _taggingHelper.DataElementLocations.BODY,
    dataElementLabel: "table-kebab",
    dataElementId: "table-kebab"
  });
}